module.exports = __webpack_public_path__ + "static/media/1022818.1a562472.jpg";